/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { RecordingsStatusByStationId } from 'client-code/recordings-status';

import { NdvrInteractor } from '../../core/interactors';
import { Log } from '../../core/logging';
import { type TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { IRecordingsStatus, setRecordingsStatusDetailsAction } from './recordings.actions';
import { SET_RECORDINGS_STATUS_DETAILS } from './recordings.types';

const initialState: IRecordingsStatus = {
    maxAge: 0,
    recordingsStatusMap: new Map<string, string>(),
};

const recordingsStatusReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<IRecordingsStatus>>{},
) => {
    switch (type) {
        case SET_RECORDINGS_STATUS_DETAILS:
            return {
                ...state,
                maxAge: payload.maxAge,
                recordingsStatusMap: payload.recordingsStatusMap,
            };

        default:
            return state;
    }
};

export default recordingsStatusReducer;

export const getRecordingsStatus = () => (dispatch: Function) => {
    const services = new NdvrInteractor();
    services
        .getRecordingsStatusDetails()
        .then((newRecordingsStatus) => {
            const RSDetails: IRecordingsStatus = {
                maxAge: newRecordingsStatus.maxAge,
                recordingsStatusMap: createRecordingsStatusMap(
                    newRecordingsStatus.recordingsStatus,
                ),
            };
            dispatch(setRecordingsStatusDetailsAction(RSDetails));
        })
        .catch((error) => {
            const TAG = 'recordingsStatus';

            Diagnostics.error(TAG, 'recordingsStatusReducer::getRecordingsStatus()');
            Diagnostics.error(TAG, 'stacktrace:', error?.stack);
            Log.e(TAG, error?.message);
        });
};

const createRecordingsStatusMap = (recordingsStatusByStationId: RecordingsStatusByStationId[]) => {
    const recordingsStatusMap = new Map<string, string>();
    recordingsStatusByStationId?.forEach((recordingStatusByStationId) => {
        recordingStatusByStationId?.recordingStatusByOfferId?.forEach((status) => {
            recordingsStatusMap.set(
                `${recordingStatusByStationId.stationId}${status.offerId}`,
                status.recordingStatus,
            );
        });
    });
    return recordingsStatusMap;
};
